import { useEffect, useState } from 'react';

const HeroSection = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=whole%20dried%20red%20chillies%20turmeric%20powder%20golden%20yellow%20thick%20rough%20desi%20cinnamon%20bark%20pieces%20whole%20dried%20cloves%20black%20cardamom%20pods%20green%20cardamom%20pods%20white%20cumin%20seeds%20fennel%20seeds%20star%20anise%20black%20peppercorns%20wooden%20spice%20bowls%20traditional%20mortar%20and%20pestle%20scattered%20on%20rustic%20wooden%20surface%20warm%20earthy%20golden%20lighting%20overhead%20flat%20lay%20premium%20organic%20handcrafted%20food%20photography%20authentic%20Pakistani%20traditional%20spice%20realism%20cinematic%20warm%20tones%20desi%20ingredients&width=1920&height=1080&seq=pf9900&orientation=landscape"
          alt="Pearl Foods organic Pakistani desi spices"
          className="w-full h-full object-cover object-top"
        />
        {/* Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-brand-brown-dark/60 via-brand-brown-dark/40 to-brand-brown-dark/70"></div>
      </div>

      {/* Hero Content */}
      <div className="relative z-10 w-full text-center px-4 md:px-8 max-w-5xl mx-auto">
        {/* Label */}
        <div
          className={`transition-all duration-700 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
          style={{ transitionDelay: '200ms' }}
        >
          <span className="inline-block font-sans text-xs md:text-sm tracking-[0.3em] uppercase text-brand-gold font-medium bg-brand-brown-dark/40 px-5 py-2 rounded-full border border-brand-gold/30 mb-6">
            Pure • Organic • Handmade
          </span>
        </div>

        {/* Headline */}
        <div
          className={`transition-all duration-700 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          style={{ transitionDelay: '400ms' }}
        >
          <h1 className="font-serif text-4xl md:text-6xl lg:text-7xl text-brand-cream font-bold leading-tight mb-6">
            Stay Close to Nature<br />
            <em className="text-brand-gold-light">with Pearl Foods</em>
          </h1>
        </div>

        {/* Subheadline */}
        <div
          className={`transition-all duration-700 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          style={{ transitionDelay: '600ms' }}
        >
          <p className="font-sans text-base md:text-xl text-brand-beige/90 max-w-2xl mx-auto mb-4 leading-relaxed">
            Pure, non-processed foods crafted with traditional methods for a healthier life.
          </p>
          <div className="flex items-center justify-center gap-3 md:gap-5 text-brand-gold text-sm font-medium font-sans mb-10 flex-wrap">
            <span className="flex items-center gap-1.5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-leaf-line"></i>
              </div>
              100% Organic
            </span>
            <span className="text-brand-gold/40">|</span>
            <span className="flex items-center gap-1.5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-hand-heart-line"></i>
              </div>
              Hand Made
            </span>
            <span className="text-brand-gold/40">|</span>
            <span className="flex items-center gap-1.5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-tools-line"></i>
              </div>
              No Machine Used
            </span>
          </div>
        </div>

        {/* CTA Buttons */}
        <div
          className={`flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-700 ${loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
          style={{ transitionDelay: '800ms' }}
        >
          <a
            href="https://wa.me/923445299984"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-brand-olive hover:bg-brand-olive-dark text-white font-sans font-medium px-8 py-4 rounded-full text-base transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <div className="w-6 h-6 flex items-center justify-center bg-white/20 rounded-full">
              <i className="ri-whatsapp-line text-sm"></i>
            </div>
            Shop via WhatsApp
          </a>
          <a
            href="#categories"
            className="flex items-center gap-2 border border-brand-beige/60 text-brand-cream hover:border-brand-gold hover:text-brand-gold font-sans font-medium px-7 py-4 rounded-full text-base transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Explore Products
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-down-line"></i>
            </div>
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-1 animate-bounce">
        <span className="text-brand-beige/50 text-xs font-sans tracking-widest uppercase">Scroll</span>
        <div className="w-4 h-4 flex items-center justify-center text-brand-gold/60">
          <i className="ri-arrow-down-s-line text-lg"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;